import { EntityColumn } from "common/entities/entity-column/types";

export const setTaxRateRange = (column: EntityColumn) =>
  column?.name === "rate" ? { ...column, minValue: 0, maxValue: 1 } : column;
